import routes from 'common/routes';

// Layouts
import LoginLayout from 'components/layout/LoginLayout';

// Public components
import AuthPortal from 'components/auth/portal/AuthPortal';
import ForgotPassword from 'components/auth/ForgotPassword';
import RegisterSuccess from 'components/auth/RegisterSuccess';
import ResetPassword from 'components/auth/reset-password/ResetPassword';
import VerifyEmail from 'components/auth/VerifyEmail';
import VerifyResetCode from 'components/auth/VerifyResetCode';

import adminRoutes from 'router/routes/adminRoutes';
import availabilityRoutes from 'router/routes/availabilityRoutes';
import clientRoutes from 'router/routes/clientRoutes';
import exerciseRoutes from 'router/routes/exerciseRoutes';
import gamificationRoutes from 'router/routes/gamificationRoutes';
import legalRoutes from 'router/routes/legalRoutes';
import mealPlanRoutes from 'router/routes/mealPlanRoutes';
import newsRoutes from 'router/routes/newsRoutes';
import notificationCenterRoutes from 'router/routes/notificationCenterRoutes';
import orgClientRoutes from 'router/routes/orgClientRoutes';
import paymentRoutes from 'router/routes/paymentRoutes';
import performanceRoutes from 'router/routes/performanceRoutes';
import planRoutes from 'router/routes/planRoutes';
import playRoutes from 'router/routes/playRoutes';
import pqrsRoutes from 'router/routes/pqrsRoutes';
import progressRoutes from 'router/routes/progressRoutes';
import sessionRoutes from 'router/routes/sessionRoutes';
import sessionTypeRoutes from 'router/routes/sessionTypeRoutes';
import supervisorRoutes from 'router/routes/supervisorRoutes';
import trainerRoutes from 'router/routes/trainerRoutes';

export const publicRoutes = [
  // '/', '/login' y '/register' renderizan el MISMO AuthPortal con un boundaryKey
  // compartido: así el portal no remonta al navegar entre ellas y la transición
  // Ingresar ↔ Crear cuenta desliza de verdad (las URLs se conservan).
  {
    key: 'home',
    exact: true,
    path: routes.home.path,
    component: AuthPortal,
    layout: LoginLayout,
    boundaryKey: 'authPortal'
  },
  {
    key: 'login',
    exact: true,
    path: routes.login.path,
    component: AuthPortal,
    layout: LoginLayout,
    boundaryKey: 'authPortal'
  },
  {
    key: 'register',
    exact: true,
    path: routes.register.path,
    component: AuthPortal,
    layout: LoginLayout,
    boundaryKey: 'authPortal'
  },
  {
    key: 'registerSuccess',
    exact: true,
    path: routes.registerSuccess.path,
    component: RegisterSuccess,
    layout: LoginLayout
  },
  {
    key: 'verifyEmail',
    exact: true,
    path: routes.verifyEmail.path,
    component: VerifyEmail,
    layout: LoginLayout
  },
  {
    key: 'forgotPassword',
    exact: true,
    path: routes.forgotPassword.path,
    component: ForgotPassword,
    layout: LoginLayout
  },
  {
    key: 'verifyResetCode',
    exact: true,
    path: routes.verifyResetCode.path,
    component: VerifyResetCode,
    layout: LoginLayout
  },
  {
    key: 'resetPassword',
    exact: true,
    path: routes.resetPassword.path,
    component: ResetPassword,
    layout: LoginLayout
  }
];

export const privateRoutes = [
  ...adminRoutes,
  ...availabilityRoutes,
  ...clientRoutes,
  ...exerciseRoutes,
  ...gamificationRoutes,
  ...legalRoutes,
  ...mealPlanRoutes,
  ...newsRoutes,
  ...notificationCenterRoutes,
  ...orgClientRoutes,
  ...paymentRoutes,
  ...performanceRoutes,
  ...planRoutes,
  ...playRoutes,
  ...pqrsRoutes,
  ...progressRoutes,
  ...sessionRoutes,
  ...sessionTypeRoutes,
  ...supervisorRoutes,
  ...trainerRoutes
];
